import { hlsMediaFormatMap, mediaFormats } from './constants';
const SUBSCRIPTION_REQUIRED_STREAM_REGEX = /^.+\/subscriptionrequired\.\w+\.mp3$/;
export function isSubscriptionRequiredStream(stream) {
    try {
        return SUBSCRIPTION_REQUIRED_STREAM_REGEX.test(stream.url);
    }
    catch {
        return false;
    }
}
export function getMediaFormat(playlistType, mediaType) {
    if (playlistType?.toLowerCase() === mediaFormats.pls) {
        return mediaFormats.pls;
    }
    const lowerCaseMediaType = mediaType?.toLowerCase() || '';
    return hlsMediaFormatMap[lowerCaseMediaType] || lowerCaseMediaType;
}
